import Vue from "vue";
import Router from "vue-router";
import Report from "./views/Report.vue";
import Dashboard from "./views/Dashboard.vue";
import NewTransactions from "./views/NewTransactions.vue";
import MonthView from "./views/MonthView.vue";
import Categories from "./views/Categories.vue";
import Rules from "./views/Rules.vue";
import Callback from "./views/Callback.vue";
import CreditCards from "./Modules/Creditcards/Creditcards.vue";
import ImportView from "./Modules/ImportTransactions/ImportView.vue";
import ExpectedTransactions from "./Modules/ExpectedTransactions/views/ExpectedTransactions.vue";
import AddExpectedTransaction from "./Modules/ExpectedTransactions/views/AddExpectedTransaction.vue";
import EditExpectedTransaction from "./Modules/ExpectedTransactions/views/EditExpectedTransaction.vue";
import ReceiptCapture from "./Modules/Receipts/ReceiptCapture.vue";
import { defaultRouteName, rememberPostLoginRoute } from "./navigation";
Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/receipts/new",
      name: "newReceipt",
      component: ReceiptCapture,
    },
    {
      path: "/credit-cards",
      name: "creditcards",
      component: CreditCards,
    },
    {
      path: "/import-transactions",
      name: "importTransactions",
      component: ImportView,
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback,
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories,
    },
    {
      path: "/categories",
      name: "categories",
      component: Categories,
    },
    {
      path: "/dashboard",
      name: "dashboard",
      component: Dashboard,
    },
    {
      path: "/expected-transactions",
      name: "expectedTransactions",
      component: ExpectedTransactions,
    },
    {
      path:"/edit-expected-transaction/:id",
      props: true,
      name: "editExpectedTransaction",
      component: EditExpectedTransaction,
    },
    {
      path: "/add-expected-transaction",
      name: "AddExpectedTransaction",
      component: AddExpectedTransaction,

    },    
    {
      path: "/logout",
      name: "logout",
      component: Dashboard,
    },
    {
      path: "/new-transactions",
      name: "newTransactions",
      component: NewTransactions,
    },
    {
      path: "/",
      redirect: () => ({ name: defaultRouteName() }),
    },
    {
      path: "/month-view/:month",
      name: "monthView",
      component: MonthView,
    },
    {
      path: "/report",
      name: "report",
      component: Report,
    },
    {
      path: "/rules",
      name: "rules",
      component: Rules,
    },
  ],
});

// very basic "setup" of a global guard
router.beforeEach((to, from, next) => {
  if (to.name == "logout") {
    router.app.$auth.logout();
  } else if (to.name == "callback") {
    // check if "to"-route is "callback" and allow access
    next();
  } else if (router.app.$auth.isAuthenticated()) {
    // if authenticated allow access
    if (!router.app.$store.state.dataInit) {
      router.app.$store.commit("setDataInit", true);
      router.app.$store.dispatch("getNewTransactions");
      router.app.$store.dispatch("getCategories");
      router.app.$store.dispatch("getRules");
      router.app.$store.dispatch("getThisMonthsTransactions");
      router.app.$store.dispatch("getLastMonthsTransactions");
    }
    next();
  } else {
    // trigger auth0 login
    rememberPostLoginRoute(to.fullPath);
    router.app.$auth.login();
  }
});

export default router;
